import { Modal } from "antd";
import CopyInput from "components/atoms/CopyInput";
import { useEffect, useState } from "react";

function CopyInputModal({ title, visible, value, onChange, readOnly, copyToolTip, onOkClick, onCancelClick }) {
    const [modalVisible, setModalVisible] = useState(visible);
    useEffect(() => {
        setModalVisible(visible);
    }, [visible]);

    return (
        <Modal title={title} centered={true} visible={modalVisible} onOk={onOkClick} onCancel={onCancelClick}>
            <CopyInput value={value} onChange={onChange} readOnly={readOnly} copyToolTip={copyToolTip}></CopyInput>
        </Modal>
    );
}

export default CopyInputModal;
